import React, { useState } from "react";
import { Dialog } from "@material-ui/core";
import { StyledPaper } from "../contractStatusReportIssuing/styles";
import { FormTitle } from "../../../homePage/styles";
import { FunctionalButton } from "../../../../components/functionalButton";
import PledgxLogo from "../../../../assets/common/pledgxLogo";
import { CloseButton } from "../../../dashboard/styles";
import CloseIcon from "@material-ui/icons/Close";
import Success from "../../../../assets/dashboardIcons/Success";
import {
  InfoArea,
  SmallTitleText,
} from "../../../underwriterDashboard/idpDocuments/styles";

type ExportPopupProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onExportToLocal: () => void;
  onExportToPartner: () => void;
  onExportToESUB: () => void;
};

export const ExportPopup = ({
  open,
  setOpen,
  onExportToLocal,
  onExportToPartner,
  onExportToESUB,
}: ExportPopupProps) => {
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);

  return (
    <>
      <SuccessPopup open={openSuccessPopup} setOpen={setOpenSuccessPopup} />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="export popup"
        aria-describedby="dialog to export data"
        maxWidth="md"
        TransitionComponent={React.Fragment}
      >
        <StyledPaper elevation={0} style={{ width: "500px" }}>
          <CloseButton onClick={() => setOpen(false)} aria-label="close">
            <CloseIcon />
          </CloseButton>
          <PledgxLogo width="60" height="60" />
          <FormTitle style={{ paddingTop: "18px" }}>Export Data</FormTitle>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
              padding: "20px 0 20px",
            }}
          >
            <FunctionalButton
              buttonTitle="Export to Local Machine"
              handleButton={() => {
                onExportToLocal();
              }}
              width="308px"
              height="48px"
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"50px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
              isReversedColor={false}
              borderColor=""
              selected={false}
              preserveCase
            />
            <FunctionalButton
              buttonTitle="Export to Partner"
              handleButton={() => {
                setOpen(false);
                onExportToPartner();
                setOpenSuccessPopup(true);
              }}
              width="308px"
              height="48px"
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"10px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
              isReversedColor={false}
              borderColor=""
              selected={false}
              preserveCase
            />
            <FunctionalButton
              buttonTitle="Attach to eSUB"
              handleButton={() => {
                setOpen(false);
                onExportToESUB();
              }}
              width="308px"
              height="48px"
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"10px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={true}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
              isReversedColor={false}
              borderColor=""
              selected={false}
              preserveCase
            />
          </div>
        </StyledPaper>
      </Dialog>
    </>
  );
};

type SuccessPopupProps = {
  open: boolean;
  setOpen: any;
};

const SuccessPopup = ({ open, setOpen }: SuccessPopupProps) => (
  <Dialog
    open={open}
    onClose={() => setOpen(false)}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="md"
  >
    <StyledPaper elevation={0} style={{ width: "800px" }}>
      <CloseButton aria-label="close" onClick={() => setOpen(false)}>
        <CloseIcon />
      </CloseButton>
      <Success isMobile={false} />
      <FormTitle
        style={{
          marginTop: "34px",
          color: "#1A051D",
          fontSize: "22px",
          fontStyle: "normal",
          lineHeight: "24px",
        }}
      >
        Data Exported
      </FormTitle>
      <SmallTitleText
        style={{
          marginBottom: 10,
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
          wordWrap: "break-word",
        }}
      >
        Your data has been exported to the partner.
      </SmallTitleText>
      <InfoArea>
        <FunctionalButton
          buttonTitle="Close"
          handleButton={() => setOpen(false)}
          width="308px"
          height="48px"
          isReversedColor={false}
          marginRight={"48px"}
          marginLeft={"48px"}
          marginTop={"30px"}
          marginBottom={"20px"}
          fontSize={"18px"}
          disabled={false}
          icon={null}
          hasBoxShadow={true}
          frontIcon={null}
          weight={600}
          borderColor=""
          selected={false}
        />
      </InfoArea>
    </StyledPaper>
  </Dialog>
);
